module.exports = __webpack_public_path__ + "img/ARS_1361.fce9ad94.jpg";